// ======================================================================
// ItemLedgerPage.jsx
// PPE → Inventory → Reports → Item Ledger
// ======================================================================

import React, { useState } from "react";
//import { fetchItemLedger } from "./itemLedgerService";
import {
  fetchItemLedger,
  exportItemLedgerExcel
} from "./itemLedgerService";

import ERPReportLayout from
"../../../../components/reports/ERPReportLayout";

import ERPFilterBar from
"../../../../components/reports/ERPFilterBar";

import ERPDataGrid from
"../../../../components/reports/ERPDataGrid";

import ERPReportActions from
"../../../../components/reports/ERPReportActions";

import "../../../../components/reports/reportStyles.css";

import MasterSearchSelect from
"../../../../../../components/common/MasterSearchSelect";

import SearchableDropdown from
"../../../../components/common/SearchableDropdown";

import warehouseLookupService from
"../stock-register/warehouseLookupService";


export default function ItemLedgerPage() {

  const [filters, setFilters] = useState({
  materialType: "",

  materialId: "",
  materialLabel: "",

  warehouseId: "",
  warehouseLabel: "",

  batch: "",
  fromDate: "",
  toDate: ""
});

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------
  // LOAD DATA
  // ------------------------------------------------
  const loadData = async () => {

    if (!filters.materialId) {
      alert("Material ID required");
      return;
    }

    setLoading(true);
    try {
      const data = await fetchItemLedger(filters);
      setRows(data.rows || []);
    } finally {
      setLoading(false);
    }
  };

  // ------------------------------------------------
  // EXPORT HANDLER
  // ------------------------------------------------
  const handleExport = async (format) => {

  try {

    if (format !== "xlsx") {
      alert("PDF export not implemented yet");
      return;
    }

    const blob =
      await exportItemLedgerExcel(filters);

    const url =
      window.URL.createObjectURL(
        new Blob([blob])
      );

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      "item_ledger.xlsx"
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {

    console.error(err);

    alert(
      "Failed to export report"
    );
  }
};

  // ------------------------------------------------
  // GRID COLUMN CONFIG
  // ------------------------------------------------
  const columns = [
  {
    key: "date",
    label: "Date",
    render: r => r.date?.slice(0, 10)
  },
  {
    key: "transaction_no",
    label: "Txn No",
    bold: true
  },
  {
    key: "transaction_type",
    label: "Type"
  },
  {
    key: "reference",
    label: "Reference",
    render: r =>
      `${r.reference_type}-${r.reference_id}`
  },
  {
    key: "material_code",
    label: "Material Code",
    width: "150px"
  },
  {
    key: "material_name",
    label: "Material Name",
    width: "220px"
  },
  {
    key: "warehouse_name",
    label: "Warehouse",
    width: "220px",
    render: r =>
      `${r.warehouse_code || ""} - ${r.warehouse_name || ""}`
  },
  {
    key: "batch_no",
    label: "Batch"
  },
  {
    key: "uom_name",
    label: "UOM"
  },
  {
    key: "qty_in",
    label: "Qty In",
    align: "right"
  },
  {
    key: "qty_out",
    label: "Qty Out",
    align: "right"
  },
  {
    key: "balance",
    label: "Balance",
    align: "right",
    bold: true
  },
  {
    key: "unit_rate",
    label: "Rate",
    align: "right"
  },
  {
    key: "value",
    label: "Value",
    align: "right"
  },
  {
    key: "posting_status",
    label: "Status"
  }
];

  // ------------------------------------------------
  // FILTER BAR
  // ------------------------------------------------
  const filterBar = (
    <ERPFilterBar
      left={
        <>
          <select
            className="erp-filter"
            value={filters.materialType}
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                materialType: e.target.value
              }))
            }
          >
            <option value="BOUGHTOUT">Bought Out</option>
            <option value="RAW_MATERIAL">Raw Material</option>
          </select>

          <MasterSearchSelect
            type="material"
            materialType={filters.materialType}
            placeholder="Search Material..."
            value={filters.materialLabel}
            onChange={(item) =>
              setFilters(prev => ({
                ...prev,
                materialId: item?.id || "",
                materialLabel:
                  item?.material_name ||
                  item?.item_name ||
                  ""
              }))
            }
          />

          <SearchableDropdown
            label=""
            value={filters.warehouseLabel}
            placeholder="Search Warehouse..."
            fetchOptions={warehouseLookupService.search}
            getOptionLabel={(o) =>
              `${o.warehouse_code} - ${o.warehouse_name}`
            }
            onChange={(v) =>
              setFilters(prev => ({
                ...prev,
                warehouseId: v.id,
                warehouseLabel:
                  `${v.warehouse_code} - ${v.warehouse_name}`
              }))
            }
          />

          <input
            placeholder="Batch"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                batch: e.target.value
              }))
            }
          />

          <input
            type="date"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                fromDate: e.target.value
              }))
            }
          />

          <input
            type="date"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                toDate: e.target.value
              }))
            }
          />

          <button
            onClick={loadData}
            className="erp-primary-btn"
          >
            Load
          </button>
        </>
      }

      right={
        <div className="flex items-center gap-4">
          <ERPReportActions onExport={handleExport} />
        </div>
      }
    />
  );

  // =====================================================
  // UI
  // =====================================================
  return (
    <ERPReportLayout
      title="Inventory — Item Ledger"
      subtitle="Detailed movement history for a material"
      toolbar={filterBar}
    >

      <ERPDataGrid
        columns={columns}
        rows={rows}
        loading={loading}
        height="600px"
      />

    </ERPReportLayout>
  );
}
